//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {
  mapState,
  mapMutations
} from "vuex";
import {
  resetPassword,
  checkPasswordToken
} from '../../service/index'
import {
  getCookie
} from '@/utils/storage'
let Base64 = require('js-base64').Base64;
export default {
  name: "Login",
  data() {
    // var checkEmail = (rule, value, callback) => {
    //   if (!value) {
    //     return callback(new Error(this.$t('login.errorEmail')));
    //   }

    //   var reg = /^(\w-*\.*)+@(\w-?)+(\.\w{2,})+$/;
    //   if (!reg.test(value)) {
    //     callback(new Error(this.$t('login.errorEmail')));
    //   } else {
    //     callback();
    //   }

    // };
    return {
      campaign: {},
      loading: true,
      invalidToken: false,
      isReg: false,
      email: '',
      loginForm: {
        passWord: "",
        passWord2: ""
      },
      // formRules: {
      //   passWord: [{
      //     required: true,
      //     message: this.$t('login.passwordTip'),
      //     trigger: 'blur'
      //   }],
      //   passWord2: [{
      //     required: true,
      //     message: this.$t('login.passwordTip'),
      //     trigger: 'blur'
      //   }]
      // },
    };
  },
  mounted() {
    if (this.$route.query.token && typeof (this.$route.query.token) !== 'undefined') {
      this.checkPasswordToken()
    } else {
      this.invalidToken = true
      this.loading = false
    }
    this.keepLang()



  },
  computed: {
    ...mapState(["global"])
  },
  methods: {
    ...mapMutations({
      setTempName: 'SET_TEMPNAME'
    }),

    async checkPasswordToken() {
      this.loading = true
      const res = await checkPasswordToken(this.$route.query.token);
      this.loading = false
      if (res.status != 0) {
        this.invalidToken = true
      } else {
        this.isReg = res.data.reg
        this.email = res.data.email
      }
    },

    resetPwd() {

      this.doResetPwd()
    },
    async doResetPwd() {
      if ((this.loginForm.passWord == '' || this.loginForm.passWord2 == '')) {
        this.$message({
          message: this.$t('login.passwordTip'),
          type: 'error'
        })
        return
      }

      if (this.loginForm.passWord != this.loginForm.passWord2) {
        this.$message({
          message: this.$t('login.equalPass'),
          type: 'error'
        })
      } else {
        const param = {
          account: this.loginForm.userName, //yimlink.defia',
          password: this.loginForm.passWord,
        }
        const loading = this.$loading({
          lock: true,
          text: '',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.2)',
          customClass: 'fullscree-loading'
        });

        const res = await resetPassword(this.$route.query.token, param);
        loading.close();
        if (res.status === 0 || res.status===1) {
          let msg= this.$t('login.resetSuccess');
          if(res.status===1){
            msg=this.$t('login.regSuccess')
          }
          this.$confirm(msg, '', {
            confirmButtonText: 'confirm',
            cancelButtonText: 'cancel',
            type: 'success',
            center: true
          }).then(() => {
            this.$router.push({
              path: '/login',
              query: {
                cid: this.$route.query.cid
              }
            })
          }).catch(() => {

          });

        } else {
          this.$message({
            message: "User Password Error! 用户名密码错误!",
            type: 'error'
          })
        }

      }

    },
    // 中英文切换事件
    switchLang() {
      if (this.$i18n.locale === 'en') {
        this.$i18n.locale = 'zh';
        localStorage.locale = 'zh';
      } else {
        this.$i18n.locale = 'en';
        localStorage.locale = 'en';
      }
    },
    // 刷新页面保存语言
    keepLang() {
      let locale = localStorage.locale;
      this.$i18n.locale = locale === 'en' ? locale : 'zh';
    },
  }
};




// WEBPACK FOOTER //
// ./src/pages/login/Resetpwd.vue